module.exports = __webpack_public_path__ + "img/10.4e1466e6.png";